let config = {
  devMqttUrl: 'http://dev.5domi.com/mqtt',
  prodMqttUrl: 'https://wx.aixyt.com/mqtt',
  // 公钥
  pubKey: `-----BEGIN PUBLIC KEY-----
  MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAO0PPEWQv4PFa7UNm4v6MGhFKUTnXegr
  d1mvIpRX0p7qNDTIi85nY929T/14EKr0xzS/ZwtG22cnp8XhapV55qkCAwEAAQ==
  -----END PUBLIC KEY-----`,
  systemAuth: 'auth'
}

export default config



// WEBPACK FOOTER //
// ./src/config/config.js